import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于在线看片平台，你可能关心的几个问题
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-50/80 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}